module.exports = __webpack_public_path__ + "img/petrova.eb3c5712.jpg";